import React from "react";
import "../styles/ewasteStyles.css";
import pdfFile from "../assets/E-Waste-Datasheet.pdf";

const Ewaste = () => {
  const blurToClearVariant = {
    hidden: { opacity: 0, filter: "blur(10px)", y: 100 },
    visible: {
      opacity: 1,
      filter: "blur(0px)",
      y: 0,
      transition: { duration: 1 },
    },
  };

  return (
    <div className="ewaste-container">
      <div className="ewaste-content">
        <div
          className="ewaste-heading"
          initial="hidden"
          whileInView="visible"
          variants={blurToClearVariant}
          viewport={{ once: false }}
        >
          <h2>E-Waste and Sustainability</h2>
        </div>
        <div
          className="ewaste-introduction"
          initial="hidden"
          whileInView="visible"
          variants={blurToClearVariant}
          viewport={{ once: false }}
        >
          <h3>Introduction</h3>
          <p>
            E-waste is a popular, informal name for electronic products nearing
            the end of their "useful life." Mobile Phones, Smart Phones, Feature
            phone, I Phones, Laptop, Desktop, Thin Clients, Air Conditioners,
            Televisions, Refrigerators, Washing Machines, VCDs, stereos,
            copiers, and fax machines are common electronic products. Many of
            these products can be reused, refurbished, or recycled.
          </p>
          <br />
          <p>
            E-waste has been one of the fastest growing waste streams in the
            world. While e-waste contains valuable materials such as aluminium,
            copper, gold, palladium and silver, it also contains harmful
            substances like cadmium, lead and mercury. In the absence of proper
            awareness, disposing e-waste in landfill can result in toxic
            emissions to the air, water and soil and pose a serious health and
            environmental hazards.
          </p>

          <br />
          <p>
            {" "}
            Under the guidelines of the Ministry of Environment, Forest and
            Climate Change, Government of India, E-Waste (Management) Rules,
            2016 and TIMEWATCH INFOCOM PRIVATE LIMITED stands committed to
            implement E-Waste Rules.
          </p>
        </div>
        <div className="ewaste-minimize">
          <div className="left-part">
            <img src="https://timewatch.co.in/images/117.png" alt="i1" />
          </div>
          <div className="right-part">
            <p
            >
              We, TIMEWATCH INFOCOM PRIVATE LIMITED understand there is a need
              to encourage recycling of all useful and valuable material from
              e-waste so as to conserve the ever depleting natural resources.
              Recycling end-of-life discarded products is vital if we are to
              save resources and minimize landfill. TIMEWATCH INFOCOM PRIVATE
              LIMITED understands its responsibility and in this regard, we have
              tied-up with one of the leading PRO namely SWACH ENVIRO INDIA
              E-WASTE PVT. LTD. for facilitating our customers to enable them to
              dispose of e-waste products after their end-of-life.
            </p>
          </div>
        </div>

        <div className="ewaste-minimize">
          {/* Left Part */}
          <div className="left-part">
            <h3>Recycling of E-waste</h3>
            <p>
              The company has tied -up with PRO M/S SWACH ENVIRO INDIA E-WASTE
              PVT. LTD. For collection of all our E-waste on PAN India and
              disposes the same with their Registered Recyclers Customer can
              reach or call on Toll Free No 18003093444. Our representatives
              explain them about process of disposal and make them aware about
              nearest drop point available to drop the e-waste also give
              information about incentive we will offer to them against their
              end of life product. If any customer wants to handover the
              material from their door steps, we do send either our logistics
              team or M/S SWACH ENVIRO INDIA E-WASTE PVT. LTD.team to collect
              the items and channelize the same to our e-waste partner plant for
              final processing.
            </p>
          </div>
          {/* Right Part */}
          <div className="right-part">
            <img src="https://timewatch.co.in/images/116.jpg" alt="img" />
          </div>
        </div>
        <div
          className="ewaste-paragraphs"
          initial="hidden"
          whileInView="visible"
          variants={blurToClearVariant}
          viewport={{ once: false }}
        >
          <br />

          <h3>Benefit of recycling of E-waste:</h3>
          <p>
            <ul>
              <li>
                E-waste contains many valuable, recoverable materials such as
                aluminum, copper, gold, silver, plastics, and ferrous metals. In
                order to conserve natural resources and the energy needed to
                produce new electronic equipment from virgin resources,
                electronic equipment can be refurbished, reused, and recycled
                instead of being land filled.
              </li>
              <li>
                E-waste also contains toxic and hazardous materials including
                mercury, lead, cadmium, beryllium, chromium, and chemical flame
                retardants, which have the potential to leach into our soil and
                water.
              </li>
              <li>
                Protects your surroundings- Safe recycling of outdated
                electronics promotes sound management of toxic chemicals such as
                lead and mercury
              </li>
              <li>
                Conserves natural resources- Recycling recovers valuable
                materials from old electronics that can be used to make new
                products. As a result, we save energy, reduce pollution, reduce
                greenhouse gas emissions, and save resources by extracting fewer
                raw materials from the earth.
              </li>
              <li>
                Helps others - Donating your used electronics benefits your
                community by passing on ready-to-use or refurbished equipment to
                those who need it.
              </li>
              <li>
                Saves landfill space - E-waste is a growing waste stream. By
                recycling these items, landfill space is conserved.
              </li>
            </ul>
          </p>
          <br />
        </div>

        <div
          className="ewaste-benefits"
          initial="hidden"
          whileInView="visible"
          variants={blurToClearVariant}
          viewport={{ once: false }}
        ></div>
        <div
          className="ewaste-do-dont"
          initial="hidden"
          whileInView="visible"
          variants={blurToClearVariant}
          viewport={{ once: false }}
        >
          <h2>Do's and Don'ts</h2>
          <div className="do-dont-container">
            <div className="do-section">
              <h3>Do's</h3>
              <ul>
                <li>
                  Always look for information on the catalogue with your product
                  for end-of-life equipment handling.
                </li>
                <li>
                  Ensure that only Authorized Recyclers repair and handle your
                  electronic products.
                </li>
                <li>
                  Always call our E-waste Authorized Collection Centres/points
                  to dispose products that have reached end-of life.
                </li>
                <li>
                  Always drop your used electronic products, batteries or any
                  accessories when they reach the end of their life at your
                  nearest Authorized E-Waste Collection Centres/Points.
                </li>
                <li>
                  Always disconnect the battery from product, and ensure any
                  glass surface is protected against breakage.
                </li>
              </ul>
            </div>
            <div className="dont-section">
              <h3>Don'ts</h3>
              <ul>
                <li>Do not dismantle your electronic Products on your own</li>
                <li>
                  Do not throw electronics in bins having “Do not Dispose” sign.
                </li>
                <li>
                  Do not give e-waste to informal (Kabbadi) and unorganized
                  sectors like Local Scrap Dealer/ Rag Pickers.
                </li>
                <li>
                  Do not dispose your product in garbage bins along with
                  municipal waste that ultimately reaches landfills.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="ewaste-paragraphs"
          initial="hidden"
          whileInView="visible"
          variants={blurToClearVariant}
          viewport={{ once: false }}
        >
          <h3>E-WASTE RECYCLING & COLLECTION MECHANISM FOR CONSUMER</h3>
          <p>
            As per the E-waste Regulation under E-waste (Management) Rule, 2016
            and{" "}
            <span style={{ color: "#f14144", fontWeight: "bold" }}>
              TIMEWATCH INFOCOM PRIVATE LIMITED{" "}
            </span>
            being a good corporate citizen understands the responsibility
            towards environment and thus following the mechanism for collection
            of e-waste and channelizing it for safe recycling.
          </p>
          <h3>How end consumer can reach us?</h3>
          <p style={{ marginTop: "1rem" }}>
            If any end consumer wishes to dispose of or recycle their
            end-of-life products or e-waste, they can contact our recycling
            partner,{" "}
            <span style={{ color: "#f14144" }}>
              SWACH ENVIRO INDIA E-WASTE PVT. LTD.
            </span>
            , via the toll-free number. A representative will guide our
            customers through the disposal process, inform them of the nearest
            drop-off points, or arrange for our logistics team to collect the
            e-waste from the customer's doorstep and ensure it is properly
            channeled to registered recyclers.
          </p>
          <h4>Take Back Scheme /collection Scheme</h4>
          <p>
            When an end consumer contacts us via the toll-free number to hand
            over their end-of-life product or e-waste for proper disposal, a
            representative from{" "}
            <span style={{ fontWeight: "bold" }}>
              {" "}
              SWACH ENVIRO INDIA E-WASTE PVT. LTD.
            </span>{" "}
            will inform them about any available incentives or exchange offers
            at that time. The representative will encourage customers to deposit
            any of their old, obsolete products (including spare parts) and
            accessories (regardless of brand) and may propose exchanging them
            for a promotional voucher or other attractive offers, depending on
            the remaining life of the product.
          </p>
          <h4>Reverse Logistic Support</h4>
          <p>
            For reverse logistics,{" "}
            <span style={{ fontWeight: "bold" }}>
              SWACH ENVIRO INDIA E-WASTE PVT. LTD.
            </span>{" "}
            has partnered with
            <span style={{ fontWeight: "bold" }}> OM LOGISTICS LTD</span>, which
            provides services across India for the collection of end-of-life
            products and e-waste. If an end consumer wishes to arrange for the
            collection of their e-waste directly from their doorstep,{" "}
            <span style={{ fontWeight: "bold" }}>
              SWACH ENVIRO INDIA E-WASTE PVT. LTD.
            </span>
            will dispatch a team from{" "}
            <span style={{ fontWeight: "bold" }}> OM LOGISTICS LTD</span> to
            collect the items and channel them to registered recycling
            facilities.
          </p>
          <h4>E-waste Exchange Scheme:</h4>
          <p>
            We will implement an e-waste exchange program that allows users to
            deposit their electronic products. In return, we will offer them a
            discount on new purchases.
          </p>
          <h4>Coupons:</h4>
          <p>
            We will also provide coupons to our existing customers, offering
            them benefits such as discounts on specific amounts or complimentary
            gifts.
          </p>
          <h4>New Product:</h4>
          <p>
            Following a sale, we will keep our customers informed about the
            availability of new products and offer them the opportunity to
            exchange their old items..
          </p>
          <div className="ewaste-minimize" >
            {/* Left Part */}
            <div className="left-part" >
              <img src="https://timewatch.co.in/images/113.png" alt="img" />
            </div>
            {/* Right Part */}
            <div className="right-part" >
              <h2
                style={{
                  marginTop: "5rem",
                }}
              >
                WHAT SHOULD I DO WITH MY ELECTRONIC DISCARDS?
              </h2>
              <p >
                The mantra of "Reduce, Reuse, Recycle" applies here:-
              </p>
              <ul>
                <li>
                  Reduce your generation of e-waste through smart handling and
                  good maintenance.
                </li>
                <li>
                  Reuse still functioning electronic equipment by donating to
                  us.
                </li>
                <li>
                  Recycle those products that cannot be repaired. Customer may
                  handover their end of life products to our nearest drop points
                  for proper Recycling.
                </li>
              </ul>
            </div>
          </div>

          <p style={{ marginTop: "2rem" }}>
            We appreciate your support in promoting the safe and responsible
            disposal of e-waste, which is a shared responsibility between our
            valued consumers and us. Your cooperation is highly valued.
          </p>
          <p style={{ fontWeight: "bold" }}>
            For more information on safe recycling and proper disposal of
            end-of-life electrical and electronic products, please contact us at
            our toll-free number: 18003093444.
          </p>
          <h2
            style={{
              marginTop: "2rem",
            }}
          >
            Designing better products
          </h2>
          <p>
            To minimize e-waste, we commit to designing or importing electronics
            that are safer, more durable, repairable, and recyclable. Our focus
            is on using fewer toxic materials and ensuring that all products are
            ROHS certified.
          </p>
          <p>
            Under our Extended Producer Responsibility (EPR) authorization, we
            take full responsibility for the management and proper disposal of
            products at the end of their lifecycle.
          </p>
          <h2
            style={{
              marginTop: "2rem",
            }}
          >
            What can I do to be part of the e waste solution?
          </h2>
          <p>
            General practices can take several steps to responsibly discard
            electronic waste, considering the current environmental concerns. It
            is no longer acceptable to leave electronic hardware on the roadside
            for garbage collection.
          </p>
          <p>
            Our recycling partner, SWACH ENVIRO INDIA E-WASTE PVT. LTD., offers
            convenient e-waste collection services. You can contact them to
            arrange for the pickup of various types of e-waste or drop it off at
            the nearest collection points.
          </p>
          <p>
            To locate e-waste recycling services near your practice, visit the
            Recycler’s website at{" "}
            <a href="http://swachenviroindia.com/">
              {" "}
              http://swachenviroindia.com
            </a>
          </p>
          <h2
            style={{
              marginTop: "2rem",
            }}
          >
            Our E-waste policy
          </h2>
          <p>
            <span style={{ fontWeight: "bold" }}>
              TIMEWATCH INFOCOM PRIVATE LIMITED
            </span>{" "}
            is committed to providing continuing, comprehensive and coordinated
            whole-personHealthcare to individuals and families in our community.
          </p>
          <p>
            <span style={{ fontWeight: "bold" }}>
              TIMEWATCH INFOCOM PRIVATE LIMITED
            </span>{" "}
            is committed to the protection of health and the environment and is
            determined to minimise any adverse impacts from its activities.
          </p>
          <p style={{ fontWeight: "bold" }}>
            TIMEWATCH INFOCOM PRIVATE LIMITED is committed to addressing the
            following issues.
          </p>
          <ul>
            <li>
              <span style={{ fontWeight: "bold" }}>Promote awareness:</span> We
              are committed to informing and motivating all our staff to
              actively participate in our e-waste disposal and environmental
              policy. By encouraging everyone to take an active role, we aim to
              ensure that our commitment to responsible e-waste management
              becomes a shared responsibility across the entire organization.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>Waste management:</span> We
              will continue to promote, develop, and implement waste prevention,
              reduction, reuse, and recycling practices onsite in a systematic
              and cost-effective manner. Additionally, we will partner with
              appropriately regulated waste management contractors to ensure the
              safe handling of hazardous and non-hazardous waste sent offsite,
              in line with best environmental practices.
            </li>
          </ul>
          <p
            style={{
              marginTop: "2rem",
            }}
          >
            Here are several strategies we can follow to help reduce e-waste:
          </p>
          <ul>
            <li>
              <span style={{ fontWeight: "bold"}}>
                Be a Smart Consumer:
              </span>{" "}
              Research thoroughly before purchasing a new product. Choose items
              that are durable and less prone to damage, with a longer lifespan.
              Many electronic products are deliberately designed with shorter
              life spans to encourage frequent replacements, so selecting
              durable items reduces the need for early replacements.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>
                Reuse Whenever Possible:
              </span>{" "}
              If your devices still work, consider repairing them rather than
              buying new ones. For irreparable devices, ensure they are recycled
              properly instead of simply discarding them.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>
                Learn About Your Electronics:
              </span>{" "}
              Educating yourself about the materials used in your devices helps
              you understand the environmental impact of improper disposal.
              Being informed allows you to make more environmentally friendly
              choices when purchasing new electronics.
            </li>
            <li>
              <span style={{ fontWeight: "bold"}}>
                Look for Eco-Friendly Certifications:
              </span>{" "}
              When buying electronics, check for labels like Energy Star or
              certifications from the Electronic Product Environmental
              Assessment Tool (EPEAT). These ensure that the product meets
              certain environmental and energy efficiency standards.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>
                Limit Gadget Ownership:
              </span>{" "}
              Avoid buying unnecessary gadgets and instead look for devices with
              multifunctional capabilities. This helps reduce electronic waste
              over time.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>
                Teach Children About E-Waste:
              </span>{" "}
              Educating kids about the importance of e-waste recycling early on
              helps instill responsible behavior towards electronics disposal.
            </li>
            <li>
              <span style={{ fontWeight: "bold"}}>
                Recycle Consistently:
              </span>{" "}
              Always ensure that old or broken electronics are disposed of
              properly through recycling. Improper e-waste disposal is
              hazardous, especially given the rising volumes of electronic
              waste.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>
                Be Aware of Security:
              </span>{" "}
              Electronic devices retain personal data even after deletion.
              Securely managing this data is another important reason to avoid
              casually discarding e-waste.
            </li>
          </ul>
          <p style={{ fontWeight: "bold" }}>
            We can further encourage recycling by implementing company-wide
            recycling programs and placing dedicated bins for customers to
            recycle their e-waste. Such programs allow old or damaged products
            to be returned, where they can be recycled, refurbished, or stripped
            for usable materials. This helps reduce environmental impact while
            promoting a circular economy for electronics.
          </p>
          <div className="ewaste-minimize">
            {/* Left Part */}
            <div  className="left-part" >
              <h2
                style={{
                  marginTop: "2rem",
                }}
              >
                Waste to Worth
              </h2>
              <p>
                Not all e-waste needs to be destroyed. Studies show that 63% of
                electronic waste can be safely recycled, offering a way to care
                for the environment while also saving significant costs.
                However, only 17% of electronic waste is currently recycled, and
                the situation is even more dire in developing countries,
                including India.{" "}
                <span style={{ fontWeight: "bold" }}>
                  SWACH ENVIRO INDIA E-WASTE PVT. LTD.
                </span>{" "}
                is committed to changing this. Our affordable and convenient
                plans make it easy to dispose of unused or outdated electronics
                in homes and offices.
              </p>
            </div>
            <div className="right-part"
              
            >
              <img src="https://timewatch.co.in/images/114.png" alt="img" />
            </div>

            {/* Right Part */}
          </div>

          <div>
            <h3 style={{ fontWeight: "bold" }}>Toner Cartridge Recycling</h3>
            <p style={{ marginTop: "0.5rem" }}>
              Toner cartridges make up nearly 12% of global e-waste, making them
              one of the largest contributors to electronic waste. SWACH ENVIRO
              INDIA E-WASTE PVT. LTD. prioritizes toner cartridge recycling
              through our dedicated division. Refilling toner cartridges can
              save up to 70% of costs and fully recycle the cartridge, offering
              a significant environmental benefit without harming the planet.
            </p>
            <h3 style={{ fontWeight: "bold" }}>Data Destruction</h3>
            <p style={{ marginTop: "0.5rem" }}>
              If you're concerned about safeguarding your personal information
              before selling a hard drive or need to remove malicious data from
              your PC, we provide certified data destruction services. Our
              process ensures complete, irreversible deletion, guaranteeing your
              privacy. Once your data is destroyed, there is no way for it to be
              recovered from the storage device.
            </p>
          </div>

          <h3 style={{ marginBottom: "1rem" }}>Our Services Include:</h3>
          <ul>
            <li>
              <span style={{ fontWeight: "bold" }}>E-Waste Recycling:</span>{" "}
              Efficiently manage and recycle your electronic waste.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>
                Toner Cartridge Recycling:
              </span>{" "}
              Specialize in the recycling and refilling of toner cartridges.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>
                PC Refurbishment for Rural Areas and NGOs:
              </span>{" "}
              Providing refurbished computers to underserved communities.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>
                Onsite Hard Disk Shredding and Scraping:
              </span>{" "}
              Securely destroy hard drives at your location.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>100% Data Destruction:</span>{" "}
              Ensure complete and irreversible deletion of your data.
            </li>
            <li>
              <span style={{ fontWeight: "bold" }}>Data Wiping:</span> Safely
              erase data from your devices.
            </li>
          </ul>
          <p style={{ marginTop: "20px" }}>
            For more information, or to reach our team, call our toll-free
            number at <span style={{ fontWeight: "bold" }}>18003093444</span>.
          </p>
          <p>
            <span style={{ fontWeight: "bold" }}>
              SWACH ENVIRO INDIA E-WASTE PVT. LTD.
            </span>{" "}
            has partnered with{" "}
            <span style={{ fontWeight: "bold" }}>OM LOGISTICS LTD</span> for
            reverse logistics, ensuring the proper channeling of e-waste to
            certified recycling facilities.
          </p>
        </div>
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <a
            href={pdfFile}
            download="E-Waste-Datasheet.pdf"
            style={{
              display: "inline-block",
              padding: "10px 20px",
              fontSize: "16px",
              fontWeight: "bold",
              color: "white",
              backgroundColor: "#4CAF50",
              textDecoration: "none",
              borderRadius: "5px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
          >
            Download PDF
          </a>
        </div>
      </div>
    </div>
  );
};

export default Ewaste;
